/** Une info de moins de deux minutes est « à l'instant », pas « il y a 1 min ». */
const JUST_NOW_IN_SECONDS = 120;

const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export interface Freshness {
  /** Unité et valeur à passer à `Intl.RelativeTimeFormat`, ou `null` si trop récent. */
  readonly value: number;
  readonly unit: Intl.RelativeTimeFormatUnit;
}

/**
 * Choisit l'unité de fraîcheur d'une information.
 *
 * Le formatage lui-même est laissé à `Intl.RelativeTimeFormat`, qui connaît les
 * règles de chaque langue — « il y a 3 heures », « 3 hours ago » — bien mieux
 * qu'un dictionnaire écrit à la main.
 *
 * Rend `null` en deçà de deux minutes : « il y a 0 minute » ne dit rien, et
 * c'est le cas de toute pastille qu'on vient de poser.
 */
export const freshnessOf = (input: { updatedAt: Date; now: Date }): Freshness | null => {
  const seconds = Math.max(0, Math.round((input.now.getTime() - input.updatedAt.getTime()) / 1000));

  if (seconds < JUST_NOW_IN_SECONDS) {
    return null;
  }

  if (seconds < HOUR) {
    return { value: -Math.floor(seconds / MINUTE), unit: "minute" };
  }

  if (seconds < DAY) {
    return { value: -Math.floor(seconds / HOUR), unit: "hour" };
  }

  return { value: -Math.floor(seconds / DAY), unit: "day" };
};
